import { CASE_TYPE } from '@repo/internal-tools-app-lib/src/lib/CaseQuestionController/constants.ts'
import * as v from 'valibot'
import { ALL_CASE_STEP_FILTER_VALUES } from '../lib/CaseTableTile/CaseTable/CaseStepColumnFilterPopoverUi/caseStepOptions.ts'
import { CASE_SUB_TYPE_FILTER_VALUES } from '../lib/CaseTableTile/CaseTable/CaseSubTypeColumnFilterPopoverUi/caseSubTypeOptions.ts'
import {
  CASE_TABLE_TILE_TABS,
  DEFAULT_CASE_TABLE_TILE_TAB,
} from '../lib/CaseTableTile/CaseTableTileTabs.ts'
import {
  CASE_ORDER,
  CASE_SORT_BY,
  DEFAULT_CASE_ORDER,
  DEFAULT_CASE_SORT_BY,
} from '../lib/CaseTableTile/constants.ts'

export const CASE_SEARCH_PARAMS_SCHEMA = v.object({
  filterType: v.optional(
    v.fallback(
      v.picklist(Object.values(CASE_TABLE_TILE_TABS)),
      DEFAULT_CASE_TABLE_TILE_TAB,
    ),
    DEFAULT_CASE_TABLE_TILE_TAB,
  ),
  caseTypes: v.optional(v.array(v.picklist(Object.values(CASE_TYPE)))),
  caseSubType: v.optional(v.picklist(CASE_SUB_TYPE_FILTER_VALUES)),
  sortBy: v.optional(
    v.fallback(v.picklist(Object.values(CASE_SORT_BY)), DEFAULT_CASE_SORT_BY),
    DEFAULT_CASE_SORT_BY,
  ),
  order: v.optional(
    v.fallback(v.picklist(Object.values(CASE_ORDER)), DEFAULT_CASE_ORDER),
    DEFAULT_CASE_ORDER,
  ),
  statuses: v.optional(
    v.fallback(
      v.array(v.picklist(ALL_CASE_STEP_FILTER_VALUES)),
      [], // Empty by default, will be set dynamically based on allowed case types
    ),
    [],
  ),
  assignees: v.optional(v.fallback(v.array(v.string()), []), []),
  // No default: the flag is absent unless the filter is on, so it never
  // materializes in the URL or on the wire for an untouched queue.
  unassigned: v.optional(v.fallback(v.boolean(), false)),
})
